import React from "react";

import styles from "./Divider.module.scss";

const Divider = ({ className, style }) => {
  return (
    <hr style={style} className={styles["root"] + (className ? " " + className : "")} />
  );
};

Divider.propTypes = {
};

export default Divider;
